import {
  getStorage,
  ref as storageRef,
  listAll,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { auth, db } from "../utils/db";
import { get, ref } from "firebase/database";

export async function fetchUserFiles() {
  try {
    const user = auth.currentUser;
    if (!user) {
      throw new Error("Usuária não está logada");
    }

    const storage = getStorage();
    const userFolderRef = storageRef(storage, `uploads/${user.uid}`);

    // Lista todos os arquivos na pasta do usuário
    const listResult = await listAll(userFolderRef);

    // Pega URL de cada arquivo
    const files = await Promise.all(
      listResult.items.map(async (itemRef) => {
        const url = await getDownloadURL(itemRef);
        return {
          name: itemRef.name,
          path: itemRef.fullPath,
          url,
        };
      })
    );

    return files;
  } catch (err) {
    console.error("Erro ao buscar arquivos do usuário:", err);
    return [];
  }
}

export async function fetchAllFiles() {
  const user = auth.currentUser;
  if (!user) {
    throw new Error("Usuária não está logada");
  }

  const storage = getStorage();
  const uploadFolderRef = storageRef(storage, `uploads/`);
  const listResult = await listAll(uploadFolderRef);
  const files = [];
  let lastUser = "";

  for (const l in listResult.prefixes) {
    const prefixRef = listResult.prefixes[l];
    const userFolderRef = storageRef(storage, prefixRef.fullPath);
    const filesResult = await listAll(userFolderRef);

    for (const f in filesResult.items) {
      const itemRef = filesResult.items[f];
      const userId = itemRef.fullPath.split("/")[1];
      const url = await getDownloadURL(itemRef);
      let username;

      if (lastUser !== userId) {
        const userRef = ref(db, `users/${userId}`);
        const userSnap = await get(userRef);
        lastUser = userId;
        username = userSnap.val().name;
      }

      files.push({
        name: itemRef.name,
        user: username,
        path: itemRef.fullPath,
        url,
      });
    }
  }

  return files;
}

export async function deleteUserFile(filePath, setFiles, presentToast) {
  try {
    const storage = getStorage();
    const fileRef = storageRef(storage, filePath);
    await deleteObject(fileRef);

    // Atualiza a lista localmente após deletar
    setFiles((prevFiles) => prevFiles.filter((f) => f.path !== filePath));
    presentToast({
      message: "Arquivo excluído com sucesso!",
      duration: 3000,
      translucent: true,
    });

    return "Arquivo excluído com sucesso!";
  } catch (err) {
    console.error("Erro ao excluir arquivo:", err);
  }
}
